import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TYPE_REPORT } from 'Constants/TypeReport'
import { RequestParams } from 'Models'

export type ReportState = {}

const initialState: ReportState = {}

export namespace ReportNS {
	export type GetReport = PayloadAction<{
		typeReport: TYPE_REPORT
		requestParams: RequestParams
		columns?: string[]
	}>
	export type SetReport = PayloadAction<Blob>
}

export const reportSlice = createSlice({
	name: 'report',
	initialState,
	reducers: {
		getReport: (state, action: ReportNS.GetReport) => {},
		setReport: (state, action: ReportNS.SetReport) => {},
	},
})
